import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ChangeEvent, memo } from 'react';
import toast from 'react-hot-toast';
import ChartHelpTooltip from '../common/ChartHelpTooltip';
import { useFormContext } from '../../contexts/FormContext';
import { useFieldValue } from '../../hooks/useFormValues';
import type { FieldComponentProps } from '../form-engine/types';

const SwitchField = ({ field }: FieldComponentProps) => {
  const { handleChange } = useFormContext();
  const value = useFieldValue(field.name!);
  // useFieldValue returns '' for an unset field: fall back to the field default (e.g. projects saved before the toggle existed).
  const checked = Boolean(value === '' ? field.default : value);

  const onToggle = (e: ChangeEvent<HTMLInputElement>) => {
    // Some toggles require a saved project (project_id) before they can be enabled,
    // e.g. HSAT which triggers API calls that need the project_id.
    if (field.requiresProjectId && e.target.checked) {
      toast.error((field.requiresProjectIdMessage as string) || 'Please save the project before enabling this option.');
      return;
    }
    handleChange({ target: { name: field.name!, value: e.target.value, type: e.target.type, checked: e.target.checked } }, field);
  };

  const label = (
    <>
      <Box component="span" sx={{ display: 'inline-flex' }}>
        <Typography color={'text.primary'}>{field.label}</Typography>
      </Box>
      {Object.prototype.hasOwnProperty.call(field, 'help') && (
        <Box component="span" sx={{ display: 'inline-flex' }}>
          <ChartHelpTooltip chartType={field.help!} />
        </Box>
      )}
    </>
  );

  return (
    <Grid size={12} key={field.label}>
      <Box sx={{ display: 'inline' }}>
        <FormControlLabel control={<Switch checked={checked} onChange={onToggle} />} label={label} />
      </Box>
    </Grid>
  );
};

export default memo(SwitchField);
